import { AbilitySpell } from 'app/frontend/types/custom/Abilities'

const NOTE_ABILITY_ID = 0
const NOTE_ICON_NAME = 'inv_misc_note_06'
const NOTE_ICON_URL = `https://render.worldofwarcraft.com/us/icons/36/${NOTE_ICON_NAME}.jpg`

const generalTimelineAbilities: AbilitySpell[] = [
  { id: NOTE_ABILITY_ID, name: 'Message', type: 'general', cooldown: 0 },
  { id: 6262, name: 'Healthstone', type: 'general', cooldown: 3600 },
  {
    id: 1234768,
    name: 'Healing Potion',
    type: 'general',
    cooldown: 300,
  },
  { id: 257872, name: 'Gateway', type: 'general', cooldown: 90 },
]

export {
  NOTE_ABILITY_ID,
  NOTE_ICON_NAME,
  NOTE_ICON_URL,
  generalTimelineAbilities,
}
